import { Filter } from './types';

export const encodeFilters = (f: Filter[]) => btoa(JSON.stringify(f));
export const decodeFilters = (encoded?: string): Filter[] => {
  try {
    return JSON.parse(atob(encoded || ''));
  } catch (error) {
    return [];
  }
};
